import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { InitializationService } from '../services/initialization.service';

export const AuthGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const initService = inject(InitializationService);

  // Wait for initialization service to be ready
  return initService.waitForReady().then(() => {
    try {
      if (authService.isAuthenticated()) {
        return true;
      } else {
        // Only navigate if not already on login page to prevent loops
        if (!window.location.pathname.includes('/login')) {
          router.navigate(['/login']);
        }
        return false;
      }
    } catch (error) {
      console.error('Auth guard error:', error);
      // Fallback: redirect to login on error
      if (!window.location.pathname.includes('/login')) {
        router.navigate(['/login']);
      }
      return false;
    }
  });
};
